var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"section-headline",attrs:{"cols":"10","lg":"8"}},[_c('h2',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }